/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDim4DiagMinIcon16Light = forwardRef('ArrowDim4DiagMinIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M13.854 2.854 10.707 6H13a.5.5 0 0 1 0 1h-3a1 1 0 0 1-1-1V3a.5.5 0 0 1 1 0v2.293l3.146-3.147a.5.5 0 0 1 .708.708Z" }),
        React.createElement("path", { d: "m6 10.707-3.146 3.147a.5.5 0 0 1-.708-.708L5.293 10H3a.5.5 0 0 1 0-1h3a1 1 0 0 1 1 1v3a.5.5 0 0 1-1 0v-2.293Z" }),
        React.createElement("path", { d: "M13 10h-2.293l3.147 3.146a.5.5 0 0 1-.708.708L10 10.707V13a.5.5 0 0 1-1 0v-3a1 1 0 0 1 1-1h3a.5.5 0 0 1 0 1Z" }),
        React.createElement("path", { d: "M2.854 2.146a.5.5 0 1 0-.708.708L5.293 6H3a.5.5 0 0 0 0 1h3a1 1 0 0 0 1-1V3a.5.5 0 0 0-1 0v2.293L2.854 2.146Z" })));
});
